<template lang="pug">
  section
    .row.padded-bottom.padded.overview
      .col-7
        h2 Try it FREE
        p.py-4 Sign-up today and start integrating your application to our API and SDK.
        router-link(
          v-if="!$store.getters.isLoggedIn"
          class="btn btn-white"
          to="/auth"
          tag="button"
        ) Try Now
        router-link(
          v-else
          class="btn btn-white"
          :to="$store.getters.redirectRoute"
          tag="button"
        ) Try Now
      .col-5
        img(
          class="lower-banner"
          src="@/assets/images/image-lower-banner.png"
          alt="overview"
        )
    footer.d-flex.flex-column
      .d-flex.flex-row.footer-top.padded
        .col-2.d-flex.flex-column
          a(href="/") Home 
          a(href="") About Us
        .col-2.d-flex.flex-column
          a(href="") Team 
          a(href="") Partners
        .col-4.d-flex.flex-column
          a(href="") Privacy Policy 
          a(href="") Terms & Condition
        .col-4.d-flex.flex-column
          span Follow Us to Stay Up to Date
          .d-flex.flex-row
            .social-btn.py-2.mr-2
              img(
                height="80%"
                src="@/assets/images/icon-twitter.png"
                alt="twitter"
              )
            .social-btn.py-2.mr-2
              img(
                height="80%"
                src="@/assets/images/icon-linkedin.png"
                alt="linkedin"
              )
            .social-btn.py-2.mr-2
              img(
                height="80%"
                src="@/assets/images/icon-facebook.png"
                alt="facebook"
              )
            .social-btn.py-2.mr-2
              img(
                height="80%"
                src="@/assets/images/icon-youtube.png"
                alt="youtube"
              )
      .padded.py-2
        small Copyright &copy;2020 Xendity. All Rights Reserved.
</template>
<script>
export default {
  data() {
    return {
      date: new Date().getFullYear(),
    };
  },
};
</script>
